import { CommonModule } from '@angular/common'
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NgModule,
  NO_ERRORS_SCHEMA,
} from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatChipsModule } from '@angular/material/chips'
import { MatNativeDateModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatMenuModule } from '@angular/material/menu'
import { MatRadioModule } from '@angular/material/radio'
import { MatSelectModule } from '@angular/material/select'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs'
import { MatTooltipModule } from '@angular/material/tooltip'
import { RouterModule } from '@angular/router'
import { ButtonsModule } from '@progress/kendo-angular-buttons'
import { ChartsModule } from '@progress/kendo-angular-charts'
import {
  DateInputModule,
  DateInputsModule,
  DateRangeModule,
} from '@progress/kendo-angular-dateinputs'
import {
  DropDownListModule,
  DropDownsModule,
} from '@progress/kendo-angular-dropdowns'
import {
  ExcelModule,
  GridModule,
  PDFModule,
} from '@progress/kendo-angular-grid'
import { IconsModule } from '@progress/kendo-angular-icons'
import { IndicatorsModule } from '@progress/kendo-angular-indicators'
import { FormFieldModule, InputsModule } from '@progress/kendo-angular-inputs'
import { IntlModule } from '@progress/kendo-angular-intl'
import { LabelModule } from '@progress/kendo-angular-label'
import { LayoutModule, TabStripModule } from '@progress/kendo-angular-layout'
import { NavigationModule } from '@progress/kendo-angular-navigation'
import { PagerModule } from '@progress/kendo-angular-pager'
import { PDFExportModule } from '@progress/kendo-angular-pdf-export'
import { ProgressBarModule } from '@progress/kendo-angular-progressbar'
import { TooltipsModule } from '@progress/kendo-angular-tooltip'
import { TreeViewModule } from '@progress/kendo-angular-treeview'

const reexports = [
  ProgressBarModule,
  NavigationModule,
  DateRangeModule,
  DateInputModule,
  FormsModule,
  ReactiveFormsModule,
  MatAutocompleteModule,
  MatBadgeModule,
  MatButtonModule,
  MatCardModule,
  MatChipsModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatNativeDateModule,
  MatSelectModule,
  MatSidenavModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
  MatRadioModule,
  ButtonsModule,
  PagerModule,
  IconsModule,
  InputsModule,
  LabelModule,
  DropDownsModule,
  LayoutModule,
  GridModule,
  ChartsModule,
  PDFModule,
  ExcelModule,
  FormFieldModule,
  TooltipsModule,
  TreeViewModule,
  IndicatorsModule,
  PDFExportModule,
  IntlModule,
  DropDownListModule,
  DateInputsModule,
  TabStripModule,
]

const components = []

@NgModule({
  imports: [CommonModule, RouterModule, ...reexports],
  declarations: [...components],
  exports: [...reexports, ...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CyborgUIModule {}
